import React from 'react';

import { IRouter } from '@routers/interface';

export const routerCheckRouter: IRouter = {
  path: '/',
  loader: React.lazy(() => import('./index')),
  exact: true,
  name: 'checkRouter.name', //translate here for breadcrumb and sidebar
  masterLayout: false,
};
